export const S3_ASSETS_BUCKET_URL = process.env.VUE_APP_S3_BUCKET ||
    'https://s3.ap-southeast-1.amazonaws.com/chatgenie.ph/cms-assets';
